import React from 'react';

import { SupportedCountryCodes } from './constants';

// Lazy load the LocationSearch component to avoid a static import of Geo,
// which conflicts with the lazy import in searchForLocationSuggestions.ts
const LocationSearch = React.lazy(() =>
  import('@aws-amplify/ui-react-geo').then((module) => ({
    default: module.LocationSearch,
  }))
);

export interface BambiMapSearchProps {
  flyToZoom: number;
  markerColor: string;
}

export function BambiMapSearch({
  flyToZoom,
  markerColor,
}: BambiMapSearchProps) {
  return (
    <div data-testid="bambi-map-search">
      <LocationSearch
        position="top-left"
        placeholder="Search map"
        countries={SupportedCountryCodes.join(',')}
        minLength={5}
        marker={{ color: markerColor }}
        showResultMarkers={{ color: markerColor }}
        popup={false}
        flyTo={{
          zoom: flyToZoom,
        }}
      />
    </div>
  );
}
